import {FormValidation} from "@blax-modules/base-front-end/resources/js/forms/form-validation";
import { waitLoad } from "@blax-modules/base-front-end/resources/js/utilities/load"

export class Newsletter {
    constructor() {
        waitLoad().then(()=>{
            new FormValidation("#frm_newsletter");
        })
    }
}